import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1433fa6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_fulfillmen_overview",
  ref: "addFulfillmentOverview",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1200px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_merchant_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "modal-body p-0" }
const _hoisted_10 = { class: "row mb-7" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group d-flex flex-wrap" }
const _hoisted_13 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "col-md-6 form-group" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-12" }
const _hoisted_21 = { class: "form-group d-flex flex-wrap" }
const _hoisted_22 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_23 = { class: "el-form-item__content" }
const _hoisted_24 = {
  key: 0,
  class: "row"
}
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group d-flex flex-wrap" }
const _hoisted_27 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group d-flex flex-wrap" }
const _hoisted_30 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_31 = {
  key: 1,
  class: "row"
}
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group d-flex flex-wrap" }
const _hoisted_34 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group d-flex flex-wrap" }
const _hoisted_37 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_38 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_39 = { class: "form-group d-flex flex-wrap" }
const _hoisted_40 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_41 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_42 = { class: "form-group d-flex flex-wrap" }
const _hoisted_43 = { class: "col-form-label required fw-bold fs-6" }
const _hoisted_44 = { class: "modal-footer flex-right" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "indicator-label" }
const _hoisted_47 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_48 = { class: "indicator-progress" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_common_channel_option = _resolveComponent("common-channel-option")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("common.add")) + _toDisplayString(_ctx.t("common.fulfillmentOrder")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("salesOrder.externalOrderNumber")), 1),
                      _createVNode(_component_el_form_item, { prop: "external_order_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.external_order_number,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.external_order_number) = $event)),
                            disabled: "",
                            type: "text",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("fulfillmentOrder.salesOrderIdentifier")), 1),
                      _createVNode(_component_el_form_item, { prop: "sale_order_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.sale_order_number,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.sale_order_number) = $event)),
                            disabled: "",
                            type: "text",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createVNode(_component_el_table, {
                  class: "mb-7",
                  ref: "multipleTableRef",
                  data: _ctx.tableData,
                  style: {"width":"100%"},
                  onSelectionChange: _ctx.handleSelectionChange,
                  width: "150"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      type: "selection",
                      width: "50"
                    }),
                    _createVNode(_component_el_table_column, {
                      property: "sku_id",
                      label: _ctx.t('order.skuIdentifier'),
                      width: "140"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.t('order.image'),
                      width: "100"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("img", {
                          class: "w-100",
                          src: scope.row.primary_image,
                          alt: "",
                          title: ""
                        }, null, 8, _hoisted_17)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.t('order.articleInformation'),
                      width: "180"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("p", null, _toDisplayString(scope.row.name_en), 1),
                        _createElementVNode("p", null, _toDisplayString(scope.row.name), 1),
                        _createElementVNode("p", null, _toDisplayString(scope.row.brand), 1),
                        _createElementVNode("p", null, _toDisplayString(scope.row.brand_article_no), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.t('order.articleAttributes'),
                      width: "120"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("p", null, _toDisplayString(_ctx.t("order.size")) + ": " + _toDisplayString(scope.row.size), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.t("order.color")) + ": " + _toDisplayString(scope.row.original_color), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.t('order.position'),
                      width: "120"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.position), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.t('order.remainingRequest'),
                      align: "right"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.qty_remained), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.t('fulfillmentOrder.spotStocks'),
                      width: "200"
                    }, {
                      default: _withCtx((scope) => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.inventory, (item, index) => {
                          return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(item.name) + "：" + _toDisplayString(item.qty), 1))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.t('order.purchaseQuantity'),
                      width: "120"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_el_input_number, {
                            class: "text-start w-100",
                            modelValue: _ctx.cloneTableData[scope.$index].quantity,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.cloneTableData[scope.$index].quantity) = $event),
                            precision: 0,
                            step: 1,
                            min: 0,
                            controls: false,
                            disabled: 
                          _ctx.cloneTableData[scope.$index].max_qty_remained <= 0 ||
                          _ctx.cloneTableData[scope.$index].max_qty_remained === ''
                        
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["data", "onSelectionChange"]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("fulfillmentOrder.fulfillmentSource")), 1),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.formData.fulfillment_type,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.fulfillment_type) = $event)),
                          size: "mini",
                          onChange: _ctx.fulfillmentTypeChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.fulfillment_type, (item) => {
                              return (_openBlock(), _createBlock(_component_el_radio, {
                                key: item.value,
                                label: item.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ])
                    ])
                  ])
                ]),
                (
                  _ctx.formData.fulfillment_type ===
                  _ctx.options.FulfillmentSource.Merchant
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.t("fulfillmentOrder.merchant")), 1),
                          _createVNode(_component_el_form_item, { prop: "merchant" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                ref: "selectMerchant",
                                onFocus: _ctx.cancelReadonly,
                                "onHook:mounted": _ctx.cancelReadonly,
                                onVisibleChange: _ctx.cancelReadonly,
                                teleported: false,
                                modelValue: _ctx.formData.merchant,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.merchant) = $event)),
                                filterable: "",
                                clearable: "",
                                "remote-show-suffix": "",
                                remote: "",
                                "remote-method": _ctx.searchMerchantSourceItems,
                                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getSalesChannelsData($event.value, true))),
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.label,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "remote-method", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("fulfillmentOrder.channel")), 1),
                          _createVNode(_component_el_form_item, { prop: "merchant_profile.channel" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.formData.merchant_profile.channel,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.merchant_profile.channel) = $event)),
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant_profile_channel, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_common_channel_option, { channelOption: item }, null, 8, ["channelOption"])
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : (
                  _ctx.formData.fulfillment_type ===
                  _ctx.options.FulfillmentSource.PreStock
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("warehouse.warehouse")), 1),
                            _createVNode(_component_el_form_item, { prop: "warehouse_key" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.formData.warehouse_key,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.warehouse_key) = $event)),
                                  clearable: "",
                                  filterable: "",
                                  placeholder: _ctx.t('common.plsSelect'),
                                  style: {"width":"100%"},
                                  onChange: _cache[7] || (_cache[7] = ($event: any) => (
                          _ctx.getFulfillmentOrderItemsSpotInventory($event, true)
                        ))
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.warehouse, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.name,
                                        value: item.key
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t("inventory.inventoryType")), 1),
                            _createVNode(_component_el_form_item, { prop: "inventory_type" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.formData.inventory_type,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.inventory_type) = $event)),
                                  clearable: "",
                                  placeholder: _ctx.t('common.plsSelect'),
                                  onChange: _ctx.getFulfillmentOrderItemsSpotInventory
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.inventory_type, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "placeholder", "onChange"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        (
                    _ctx.formData.warehouse_key !== '' &&
                    _ctx.formData.inventory_type !== ''
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("fulfillmentOrder.merchant")), 1),
                                _createVNode(_component_el_form_item, { prop: "merchant" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      class: "w-100",
                                      modelValue: _ctx.formData.merchant,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.merchant) = $event)),
                                      clearable: "",
                                      filterable: "",
                                      placeholder: _ctx.t('common.plsSelect'),
                                      onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getSalesChannelsData($event, true)))
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.id,
                                            label: item.name + ' (' + item.qty + ')',
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "placeholder"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (
                    _ctx.formData.warehouse_key !== '' &&
                    _ctx.formData.inventory_type !== ''
                  )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.t("fulfillmentOrder.channel")), 1),
                                _createVNode(_component_el_form_item, { prop: "merchant_profile.channel_key" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.formData.merchant_profile.channel_key,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.merchant_profile.channel_key) = $event)),
                                      clearable: "",
                                      placeholder: _ctx.t('common.plsSelect'),
                                      onChange: _ctx.channelChange
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant_profile_channel, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.key,
                                            label: item.name + ' (' + item.qty + ')',
                                            value: item.key
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "placeholder", "onChange"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                ref: "submitButton",
                type: "submit",
                class: "btn btn-lg btn-primary",
                disabled: _ctx.isDisabledSubmit
              }, [
                _createElementVNode("span", _hoisted_46, [
                  _createElementVNode("span", _hoisted_47, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_48, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_49
                ])
              ], 8, _hoisted_45)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}